import { CommandMenuQueryNode } from '#pplx/frontend/composer-sdk/lexical/nodes/CommandMenuQueryNode.js';
import { SlashHintNode } from '#pplx/frontend/composer-sdk/lexical/nodes/SlashHintNode.js';
/**
 * Lexical node classes required by surfaces declaring `TypeaheadCapability`.
 * Registered automatically by `<Composer />` when a plugin declares the
 * capability — never wire these directly on a consumer's `initialConfig`.
 */
export const TYPEAHEAD_CAPABILITY_NODES = [
    SlashHintNode,
    CommandMenuQueryNode,
];
//# sourceMappingURL=typeahead.js.map